import DOMPurify from 'isomorphic-dompurify'

/**
 * @function sanitizeHtml
 * @param {string} html
 * @returns {string}
 */
export const sanitizeHtml = DOMPurify.sanitize
